// extracted by mini-css-extract-plugin
module.exports = {"popup_wrapper":"LoginPopup_popup_wrapper__1ozg6"};